import { Button } from '@/components/Button/Button'
import { Popup } from '@/components/Popup/Popup'
import { usePostsState } from '@/state/posts'
import type { FunctionalComponent } from 'preact'
import { useState } from 'preact/hooks'

export const RemovePostPopup: FunctionalComponent<{
  postId: number
  onClose: () => void
}> = props => {
  const removePost = usePostsState(s => s.remove)
  const [loading, setLoading] = useState(false)

  return (
    <Popup
      onClose={props.onClose}
    >
      <Popup.Title>
        Remove post?
      </Popup.Title>
      <Popup.Footer>
        <div />
        <Popup.Buttons>
          <Button
            disabled={loading}
            onClick={props.onClose}
          >
            Cancel
          </Button>
          <Button
            disabled={loading}
            type='primary'
            onClick={async () => {
              try {
                setLoading(true)
                await removePost(props.postId)
                props.onClose()
              }
              catch (e) {
                console.error(e)
              }
              finally {
                setLoading(false)
              }
            }}
          >
            Remove
          </Button>
        </Popup.Buttons>
      </Popup.Footer>
    </Popup>
  )
}
